import Header from './Header'
import Footer from './Footer'

function CiudadaniaItaliana() {
    const title =  'Ciudadanía italiana'
    return (
        <>
            <Header/>
            <main id="main">
                {/* ======= Breadcrumbs ======= */}
                <section id="breadcrumbs" className="breadcrumbs">
                  <div className="container">
                    <ol>
                      <li><a href="/">Inicio</a></li>
                      <li>{title}</li>
                    </ol>
                    {/*h2>{title}</h2*/}
                    <div className="row">
                      <div className="col-lg-6 order-1 order-lg-2" data-aos="fade-left">
                        <img src="assets/img/ciudadania-italiana.png" className="img-fluid" alt="ciudadanía italiana" style={{'padding': '5% 10% 10% 10%'}} />
                      </div>
                      <div className="col-lg-6 pt-4 pt-lg-0 order-2 order-lg-1 content" data-aos="fade-right">
                        <h3>{title}</h3>
                        <p className="justified-text">La <strong>Ley 74/2025</strong>, vigente desde el 24 de mayo de 2025, introdujo un <strong>límite generacional</strong> al reconocimiento de la ciudadanía italiana <em>iure sanguinis</em>: solo pueden acceder quienes tengan un padre o abuelo nacido en Italia que haya fallecido conservando su ciudadanía italiana. En otras palabras, el derecho se limita a <strong>hijos y nietos</strong> de italianos.</p>
                        <br/>
                        <div style={{display: 'flex', gap: '15px', flexWrap: 'wrap'}}>
                          <a href="/ciudadania-italiana-servicios" className="cta-button">Conocé nuestros servicios</a>
                          <a href="https://wa.me/+5491124089830?text=Hola%2C%20quiero%20consultar%20por%20ciudadan%C3%ADa%20italiana" className="cta-button" style={{background: 'transparent', border: '2px solid #b41e1e', color: '#b41e1e'}}>Hablemos de tu caso</a>
                        </div>
                      </div>
                    </div>
                  </div>
                </section>{/* End Breadcrumbs */}
            </main>
            <Footer/>
        </>
    );
}

export default CiudadaniaItaliana;
